import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getIconByName } from '../../../utils/iconMap';
import { portalContentMaxWidthSx, portalPageHorizontalPaddingSx } from '../../../theme/portalLayout';
const HowItWorksSection = ({ heading, subheading, steps = [], }) => {
    const theme = useTheme();
    return (_jsx(Box, { id: "how-it-works", component: "section", sx: {
            bgcolor: '#f3f4f6',
            py: { xs: 5, md: 7 },
            ...portalPageHorizontalPaddingSx,
            scrollMarginTop: 16,
        }, children: _jsxs(Box, { sx: portalContentMaxWidthSx, children: [_jsxs(Box, { sx: { textAlign: 'center', mb: { xs: 4, md: 5 } }, children: [_jsx(Typography, { variant: "h3", component: "h2", sx: {
                                fontWeight: 800,
                                color: 'primary.dark',
                                fontSize: { xs: '1.65rem', md: '2.125rem' },
                                mb: 1.5,
                            }, children: heading }), subheading && (_jsx(Typography, { variant: "body1", sx: {
                                color: 'text.secondary',
                                maxWidth: 720,
                                mx: 'auto',
                                lineHeight: 1.65,
                            }, children: subheading }))] }), _jsx(Box, { sx: {
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' },
                        alignItems: { md: 'stretch' },
                        gap: { xs: 2.5, md: 0 },
                    }, children: steps.map((step, index) => {
                        const Icon = getIconByName(step.icon);
                        const stepNum = String(index + 1).padStart(2, '0');
                        const isLast = index === steps.length - 1;
                        return (_jsxs(React.Fragment, { children: [_jsxs(Box, { sx: {
                                        flex: { md: '1 1 0' },
                                        minWidth: { md: 0 },
                                        bgcolor: '#ffffff',
                                        borderRadius: 2.5,
                                        p: { xs: 2.25, md: 2.5 },
                                        boxShadow: '0 4px 24px rgba(0, 40, 85, 0.08)',
                                        border: '1px solid rgba(0, 40, 85, 0.06)',
                                    }, children: [_jsxs(Box, { sx: {
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'flex-start',
                                                mb: 2,
                                            }, children: [_jsx(Box, { sx: {
                                                        width: 44,
                                                        height: 44,
                                                        borderRadius: 1.5,
                                                        bgcolor: 'primary.main',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        flexShrink: 0,
                                                    }, children: _jsx(Icon, { sx: { fontSize: 22, color: '#fff' } }) }), _jsx(Typography, { sx: {
                                                        fontSize: { xs: '2rem', md: '2.25rem' },
                                                        fontWeight: 800,
                                                        lineHeight: 1,
                                                        color: theme.palette.grey[300],
                                                        userSelect: 'none',
                                                    }, children: stepNum })] }), _jsx(Typography, { variant: "subtitle1", sx: {
                                                fontWeight: 700,
                                                color: 'primary.dark',
                                                mb: 1,
                                                textAlign: 'left',
                                            }, children: step.title }), _jsx(Typography, { variant: "body2", sx: {
                                                color: 'text.secondary',
                                                lineHeight: 1.55,
                                                textAlign: 'left',
                                            }, children: step.description })] }), !isLast && (_jsx(Box, { "aria-hidden": true, sx: {
                                        display: { xs: 'none', md: 'flex' },
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexShrink: 0,
                                        width: 28,
                                        alignSelf: 'center',
                                    }, children: _jsx(Box, { sx: {
                                            width: '100%',
                                            borderTop: '2px dotted',
                                            borderColor: 'rgba(0, 40, 85, 0.22)',
                                        } }) }))] }, index));
                    }) })] }) }));
};
export default HowItWorksSection;
